<template>
    <v-container style="cursor: pointer;"  @click="$emit('click')">
        <v-row class="py-1">
            <v-col :cols="12">
                <v-img contain :style=customstyle :width=width :height=height :src="url" :key="url" @mouseover="imgMouseOver()" @mouseleave="imgMouseLeave()">
                    <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular v-show="url==null" size="60" width="8" indeterminate color="indigo darken-2"></v-progress-circular>
                    </v-row>
                </v-img>
            </v-col>
        </v-row>
    </v-container>
    </template>
    
    <style>
    .color-picker {
        background-color: white;
    }
    
    .v-menu__content .container {
        background-color: white;
    }
    .short {
        min-width: 100px;
    }
    </style>
    
    <script>
    import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
    import axios from "axios";
    // import debounce from "lodash.debounce";
    export default {
        name: "Kwang-qrcode-view",
        props: {
            data: {
                type: String,
                default: 'test qrcode string',
            },
            width: {
                default: 100,
            },
            height: {
                default: 100,
            },
            customstyle: {
                default: "position:absolute;right: 15px; top: 0px;",
            },

        },
        computed: {
            leftCol() {
                /*if (this.mode == "configure") {
                    return 6;
                }*/
                return 12;
            }
        },
        methods: {
            filesChange(evt) {
                console.log("filesChange", evt);
                const reader = new FileReader();
                var self = this;
                reader.addEventListener("load", function () {
                    // convert image file to base64 string
                    //preview.src = reader.result;
                    console.log("previewFile", reader.result);
                    self.logo = reader.result;
                    //AngularScope().logo = reader.result;
                    //AngularScope().reDraw();
                    //$scope.logo = reader.result;
                    //$scope.reDraw();
                }, false);
                var file = evt.target.files[0];
                if (file) {
                    reader.readAsDataURL(file);
                }
            },
            imgMouseOver() {
                // if (this.showSettingButton == false && this.url != null) {
                //     this.showSettingButton = true;
                // }
            },
            imgMouseLeave() {
                // if (this.showSettingButton) {
                //     if (this.showSetting == false) {
                //         this.showSettingButton = false;
                //     }
                // }
            },
    
            async getQRCode(qrcodeData) {
                var myOption = {
                    ...this.defaultOption,
                    ...this.qrTemplate[this.currentTemplate]
                };
                if (this.logo != "") {
                    myOption.logo = this.logo;
                }
                var self = this;
                /*axios.post(this.apiMultiEndPoint, JSON.stringify({
                    command: "qrcode",
                    text: qrcodeData,
                    option: myOption,
                    imageFormat: "png",  //png,jpg
                    outputFormat: "dataUrl",   //buffer,dataUrl
                }))
                .then(function (response) {
                    console.log(response);
                    self.url = response.data.data;
                    self.$emit('generated',self.url);
                })
                .catch(function (error) {
                    console.log(error);
                });*/
                //var fakeData = {"command":"qrcode","text":"https://docs.aws.amazon.com/lambda/latest/dg/nodejs-package.html","option":{"margin":"0","color":{"dark":"#7e15ffFF","light":"#F1F1F1FF","lefttop":"#ff9110FF","righttop":"#02e1e4FF","leftbottom":"#de0ecfFF","svgLogo":"#000000FF","lefttopeye":"#fa6e79FF","righttopeye":"#00bfffFF","leftbottomeye":"#2d7cdaFF","frame":"#000000FF","frameText":"#FFFFFFFF"},"width":500,"cellMode":"square","svgLogo":"","frame":"bottomToolTip","frameText":"Hello World","marker":{"lefttop":"version1","righttop":"version1","leftbottom":"version1"}},"imageFormat":"png","outputFormat":"dataUrl"};
                //  var fakeData = {"command":"qrcode","text":"https://docs.aws.amazon.com/lambda/latest/dg/nodejs-package.html","option":{"margin":"0","color":{"dark":"#7e15ffFF","light":"#F1F1F1FF","lefttop":"#ff9110FF","righttop":"#02e1e4FF","leftbottom":"#de0ecfFF","svgLogo":"#000000FF","lefttopeye":"#fa6e79FF","righttopeye":"#00bfffFF","leftbottomeye":"#2d7cdaFF","frame":"#000000FF","frameText":"FFFFFFFF"},"width":500,"cellMode":"square","frame":"bottomFrame","frameText":"Hello World","svgLogo":"","name":"normal","marker":{"lefttop":"version1","righttop":"version1","leftbottom":"version1"}},"imageFormat":"png","outputFormat":"dataUrl"}; 
                //const response = await axios.post(this.apiMultiEndPoint, JSON.stringify(fakeData));
                const response = await axios.post(this.apiMultiEndPoint, JSON.stringify({
                    command: "qrcode",
                    text: qrcodeData,
                    option: myOption,
                    imageFormat: "png", //png,jpg
                    outputFormat: "dataUrl", //buffer,dataUrl
                }));
                
                self.url = response.data.data;
                console.log("getQRCode",self.url)
                self.$emit('generated', self.url);
            },
            dataURLtoBlob(dataURL) {
                const byteString = atob(dataURL.split(',')[1]);
                const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ab], { type: mimeString });
            },
            saveImage() {
                var text = this.dataURLtoBlob(this.url);
                var url = window.URL.createObjectURL(new Blob([text], { type: "text/plain" }));
                var anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = "qrcode.png";
                // (E) "FORCE DOWNLOAD"
                // NOTE: MAY NOT ALWAYS WORK DUE TO BROWSER SECURITY
                // BETTER TO LET USERS CLICK ON THEIR OWN
                anchor.click();
                window.URL.revokeObjectURL(url);
                anchor.remove();
            },
        },
        created() {
            // this.debouncedWatch = debounce((newValue, oldValue) => {
            //     console.log("debouncedWatch", oldValue, "->", newValue);
            //     this.getQRCode(this.data);
            // }, 500);
        },
        mounted() {
            console.log("data()", this.data);
            this.getQRCode(this.data);
        },
        beforeUnmount() {
            //this.debouncedWatch.cancel();
        },  
        watch: {
            data: function (...args) {
                
                // if(args[0]!=null){
                // }else{

                // }
                if(args[0]!=null){
                    this.url = null;
                    this.getQRCode(args[0]);
                    // this.debouncedWatch(...args);
                }
            },
            // currentTemplate: function (...args) {
            //     this.url = null;
            //     this.debouncedWatch(...args);
            // },
            // logo: function (...args) {
            //     this.url = null;
            //     this.debouncedWatch(...args);
            // },
            // defaultOption: {
            //     deep: true,
            //     handler(...args) {
            //         this.url = null;
            //         this.debouncedWatch(...args);
            //     }
            // },
        },
        data() {
            return {
                apiMultiEndPoint: "https://cntebx33x5.execute-api.us-west-1.amazonaws.com/stage/qrcode",
                url: null,
                showSettingButton: false,
                showSetting: false,
                //url: "data:image/png;base64,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",
                defaultOption: {
                    margin: "0",
                    color: {
                        dark: "#000000DE",
                        light: "#F1F1F1FF",
                        lefttop: "#000000DE",
                        righttop: "#000000DE",
                        leftbottom: "#000000DE",
                        svgLogo: "#000000DE",
                        lefttopeye: "#000000DE",
                        righttopeye: "#000000DE",
                        leftbottomeye: "#000000DE",
                        frame: "#000000DE",
                        frameText: "#F1F1F1FF",
                    },
                    cellMode: "square",
                    width: 500,
                    frame: "",
                    frameText: "Hello World",
                    svgLogo: "",
                },
                menu: null,
                currentTemplate: 0,
                uploadFieldName: "",
                logo: "",
                qrTemplate: [{
                    name: "normal",
                    marker: {
                        lefttop: "version1",
                        righttop: "version1",
                        leftbottom: "version1",
                    }
                }],
            }
        },
    }
    </script>
    